import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from "react";
class FileInput extends Component {
    files;
    constructor(props) {
        super(props);
        this.uploadFile = this.uploadFile.bind(this);
        this.files = [];
    }
    uploadFile(event) {
        this.files = [];
        if (!event.target.files) {
            const message = "no files uploaded";
            console.error("no files uploaded");
            alert(message);
            return;
        }
        const invalidFileNames = [];
        for (const file of event.target.files) {
            if (!file.name.endsWith(".zip")) {
                invalidFileNames.push(file.name);
            }
            else {
                this.files.push(file);
                //console.log(`File uploaded: ${file.name}`);
            }
        }
        if (invalidFileNames.length > 0) {
            const message = `Non-ZIP file uploaded: ${invalidFileNames}`;
            console.error(message);
            alert(message);
            return;
        }
        this.props.onUploadFinished(this.files);
    }
    render() {
        return (_jsx("span", { children: _jsx("input", { type: "file", name: "files", accept: ".zip", onChange: this.uploadFile }) }));
    }
}
export default FileInput;
